import React from 'react';

export default () => (<div> Error </div>);
